import { render } from "./ProductCell.vue?vue&type=template&id=644cbf6f&scoped=true"
import script from "./ProductCell.vue?vue&type=script&lang=js"
export * from "./ProductCell.vue?vue&type=script&lang=js"

import "./ProductCell.vue?vue&type=style&index=0&id=644cbf6f&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644cbf6f"]])

export default __exports__